import React from 'react'
import PagesLayout from '..'

export default function CerimonyPage() {
  return (
    <PagesLayout
      title="Cerimônias"
      description="Enviar condolências é simples com a KFamily: envie sua mensagem, receba a confirmação e nós garantimos que ela chegue ao destinatário certo de forma rápida e segura."
    >
      <br />
      <br />
      <br />
      Em desenvolvimento.
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </PagesLayout>
  )
}
